import type {BioIconProps} from '../../icons/common-types'

export default function BestPetEssentialsPicksLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.6"
          d="M26.2945 21.7882C25.5079 17.0816 20.9879 13.2549 16.2145 13.2549C11.0279 13.2549 6.46787 17.4549 6.02787 22.6282C5.85454 24.6282 6.49453 26.5216 7.81453 27.9482C9.1212 29.3749 10.9612 30.1616 12.9612 30.1616H19.2012C21.4545 30.1616 23.4279 29.2815 24.7745 27.6949C26.1212 26.1082 26.6545 24.0016 26.2945 21.7882Z"
          fill="#EDEDED"
        />
        <path
          d="M14.5551 11.3085C16.7127 11.3085 18.4618 9.55938 18.4618 7.40178C18.4618 5.24419 16.7127 3.49512 14.5551 3.49512C12.3975 3.49512 10.6484 5.24419 10.6484 7.40178C10.6484 9.55938 12.3975 11.3085 14.5551 11.3085Z"
          fill="#EDEDED"
        />
        <path
          d="M23.4408 12.868C25.2376 12.868 26.6942 11.4114 26.6942 9.61466C26.6942 7.8179 25.2376 6.36133 23.4408 6.36133C21.6441 6.36133 20.1875 7.8179 20.1875 9.61466C20.1875 11.4114 21.6441 12.868 23.4408 12.868Z"
          fill="#EDEDED"
        />
        <path
          d="M28.2484 18.0682C29.6844 18.0682 30.8484 16.9041 30.8484 15.4682C30.8484 14.0322 29.6844 12.8682 28.2484 12.8682C26.8125 12.8682 25.6484 14.0322 25.6484 15.4682C25.6484 16.9041 26.8125 18.0682 28.2484 18.0682Z"
          fill="#EDEDED"
        />
        <path
          d="M6.1049 15.4686C7.90166 15.4686 9.35823 14.012 9.35823 12.2152C9.35823 10.4185 7.90166 8.96191 6.1049 8.96191C4.30813 8.96191 2.85156 10.4185 2.85156 12.2152C2.85156 14.012 4.30813 15.4686 6.1049 15.4686Z"
          fill="#EDEDED"
        />
      </svg>
      <span>Best Pet Essential Picks</span>
    </div>
  )
}
